/**
 *    @author: Andrew Sheen
 *    @since:  2021-03-14
 *
 */

import { Component, ViewChild,OnInit} from '@angular/core';
import { Router } from '@angular/router'; 
import { TimerService } from 'src/refresh/service/timer-service';
import { FormBaseComponent } from '../_common/component/form-base.component';
import { AboutChild, Eligibility, InputData } from '../_common/data/input-data';
import { Path, Progress } from  "../_common/constant/page-const";
import { NextRegistrationValidation } from './next_registration.validator';
import { ItemList } from '../_common/constant/item-list';
import { BirthdayComponent } from '../setup_1/birth-day/birth-day.component';
import { ChildDeceasedComponent } from '../setup_2/child-deceased/child-deceased.component';
import { Confirm } from 'src/refresh/service/constant';
import { SubmitApplication } from '../_common/submit/SubmitApplication';
import { HttpClient } from '@angular/common/http';
import { ProgressService } from 'src/refresh/service/progress-service';
import { ViewportScroller } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Component({ 
      selector: 'next_registration',
      templateUrl: './next_registration.component.html',
      styleUrls: ['./next_registration.component.less']
})
export class NextRegistrationComponent extends FormBaseComponent implements OnInit {

       public error_nextChild:string;
       public error_sameAddress:string;
       public error_sameBirthday:string;

       public aboutChild:AboutChild;

       public childParam:Object;
       
       private submitApplication:SubmitApplication;

       public  button_alt_nextService:string;
       public  button_alt_nextChild:string;

       public  disabled:boolean = true;

       @ViewChild(BirthdayComponent)      birthday:BirthdayComponent;
       @ViewChild(ChildDeceasedComponent) childDeceased:ChildDeceasedComponent;
       
       constructor( protected router: Router ,
                    public timerService:TimerService,
                    private translate: TranslateService,
                    protected progress:ProgressService,
                    public items:ItemList,
                    public data:InputData ,
                    httpClient:HttpClient,
                    public viewportScroller: ViewportScroller) {

                    super(router,timerService);  
                    super.setNextPage(Path.ProvincialPayment,Path.OrderSummary);
                    super.setValidator(new NextRegistrationValidation(this));

                    this.submitApplication = new SubmitApplication(httpClient,data,timerService,items);
                    
                    this.aboutChild = this.data.aboutChild;

                    this.childParam = { childBirth: this.items.dateFormat(this.aboutChild.birthDay) };

                    this.disabled = !!data.subject.siteKey;

                    InputData.currentPageIdx = 24;
                    if ( InputData.moveNext == 0 || InputData.moveNext == InputData.currentPageIdx ) this.timerService.isForwarding = false;
       }

       public onNextClick(): boolean {

            this.timerService.reset();

            if (this.validator.validate() == false ) return;
          
            if ( this.aboutChild.isNextChild == Confirm.YES ) {

                 let birthDay = this.aboutChild.nextBirthDay;

                 if( this.aboutChild.isSameBirthday == Confirm.YES )
                     birthDay = this.aboutChild.birthDay;

                 this.data.addChild(birthDay,this.aboutChild.nextChildDeceased,this.aboutChild.isSameAddress)

                 super.setNextPage(Path.AboutTheChildMain,Path.OrderSummary);
                 this.progress.nextChild(Progress.AboutChild);
                 this.progress.adjustBundles(this.data);
            }
            else {

                 if (  this.data.orderOfBC.total == 0 ) {
                       if ( this.disabled == false )
                            this.submitApplication.submit();
                       return;
                 }
            }

            this.router.navigate([this.nextURL]);    // ProvincialPayment
            return true;
       }

       public ngOnInit() {

              super.forwardNext(0);
              this.button_alt_nextService = this.translate.instant("next_registration.continue_alt1");                        
              this.button_alt_nextChild   = this.translate.instant("next_registration.continue_alt2");                        
       }

       public resolved(captchaResponse: string) {
              
            this.data.subject.captcha = captchaResponse;
            this.disabled = false;
      }

      public onNextChild() {

             let elem = document.getElementById("btn-next");
             
             if ( this.data.aboutChild.isNextChild  == Confirm.YES )
                  elem.title = this.button_alt_nextChild;
             else elem.title = this.button_alt_nextService;
      }
}
